<template>
	<div id="repositorydetai">
		<!--主体内容-->
		<div class="repositprymain">
			<!--左侧-->
			<div class="repositorycontent">
				<h2>{{title}}</h2>
				<ul>
					<li>
						<span class="source_img" >
							<i class="el-icon-thirdicon-yonghu-tianchong"></i>
						</span>	
						<a>{{source}}</a>
					</li>
					<li>
						<span class="el-icon-view">
							
						</span>
						<a>{{view}}</a>
					</li>
					<li>
						<span class="el-icon-time">
							
						</span>
						<a>{{createtime}}</a>
					</li>
					<!-- <a>
						<span v-if='!collection_flag' style="font-family: '微软雅黑';color: #73777A;"><span style="cursor: pointer;" @click="collectResponse" class="el-icon-star-off"></span>收藏</span>
						<span v-if='collection_flag' style="font-family: '微软雅黑';color: #73777A;"><span style="cursor: pointer;color: #076bf2;" @click="collectResponse" class="el-icon-star-on"></span>收藏</span>
					</a> -->
				</ul>
				<!--展示内容-->
				<div class="showcontent">
					<div  class="repository_pdf" v-if="contentType=='3'&& numPages" v-for="item in pagea" :id="'pdf_box'+item">
						<pdf
				            v-for="i in 1"
				            :key="i"
				            :src="src"
				            :page="item"
				            style="display: inline-block; width:100%"
				        ></pdf>
				        <!--<div :id="'pagecount'+item">
				        	第{{item}}页
				        </div>-->
					</div>
					<div v-if="contentType=='1'" id="html_box">
						 <div id="html_box_child"  v-html="html1">
						 	
						 </div>
					</div>
				</div> 
				<!--展示更多-->
				<div v-if="repository_showmore" class="showmorere">
					<button id="re_showmore" @click="showmorepage" style="color:#2978EF;background-color: #FFFDEF;border: 0;cursor: pointer;"><span class="el-icon-thirdicon-gengduo-copy"></span>点击展开更多</button>
				</div>
			</div>
			<!--右侧-->
			<div class="repositorycorrelation">
				<div class="related_doc" v-if="correlation.length">
					
					<div class="title">
						相关文档推荐
					</div>
					<ol>
						<li v-for="item in correlation">
							<h5 style="cursor: pointer;" @click="relativedoc(item.vc_contentcode,item.n_contenttype,item.vc_content)">{{item.vc_title}}</h5>
							<div class="doc">
								<div class="suiyi">
									<span class="el-icon-view">{{item.vc_page_view}}</span>
								</div>
								<span class="page">
									{{item.dt_updatetime}}
								</span>
							</div>
						</li>
					</ol>
				</div>
				<div class="share_link">
					<div class="title">
						立即分享
					</div>
					<span  class="share">
						分享链接
					</span>
					<div class="inputwrap">
						<textarea class="textarea1" v-model="shareUrl" spellcheck ="false"></textarea>
					</div>
					<span @click="copyurl" class="span_button">
						复制链接
					</span>
				</div>
			</div>
		</div>
		<submitquestionpop ref='submitquestionpop'></submitquestionpop>
	</div>
</template>

<script>
	import Bus from '@/bus.js'
	import pdf from 'vue-pdf'
	import submitquestionpop from '@/messageBox/submitquestionpop.vue'
	export default {
		data() {
			return {
				repository_showmore:false,
				coverphoto:'',
				shareUrl:'',			//分享链接
				pagea:3,				//默认显示页数
				src: '',				//PDF文件路径
           		numPages: undefined,	//PDF文件总页数
				uuid:'',				//知识uuid
				title:'',				//知识标题
				view:'',				//阅读量
				source:'',				//发布人
				content:'',				//知识内容
				createtime:'',			//发布时间
				collection_flag:0,		//是否收藏
				contentShow:0,			//是否显示内容
				correlation:'',			//相关文档
				contentType:1,		//内容类型
				html1:``,			//富文本
			}
		},
		components: {
			submitquestionpop,
			pdf
		},
		mounted(){
			let _this=this;
			this.uuid = this.$route.query.uuid;
			this.shareUrl = window.location.href;
			//获取数据
			this.$http.get(
				_this.apiUrl+'index.php? m=Api&c=Content&a=repositoryDetail',
				{
					params: {  
						"uuid":this.uuid,
						'userCode':sessionStorage.getItem('usercode')
					}  
				}
			).then(response => {
				//进行数据验证
				if(response.body.status != 1){
					
					//显示错误页面
//					alert('请求错误');
					return;
				}
				if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == ""){
					//显示空数据页面
//					alert('没有数据');
					return;
				}
				this.coverphoto=response.body.data.vc_coverphoto;
				this.title = response.body.data.vc_title;
				this.view = response.body.data.vc_page_view;
				this.source = response.body.data.vc_source;
				this.content = response.body.data.vc_content;
				this.createtime = response.body.data.dt_createtime;
				this.collection_flag = response.body.data.is_collection;
				this.correlation = response.body.data.correlation;
				this.contentType = response.body.data.n_contenttype;
				
				this.contentShow = 1;
				//根据类型判断
				if(this.contentType==1){
					this.html1=this.content;
				}else{
//				let loadingTask = pdf.createLoadingTask('http://datagalaxy.yeesight.com/v2/admin/'+this.content);
				let loadingTask = pdf.createLoadingTask(_this.apiUrl+this.content);
				this.src=loadingTask;
				this.src.then(pdf => {
            	this.numPages = pdf.numPages;
            	if(pdf.numPages>3){
            		this.repository_showmore=true;
            	}else{
            		this.pagea=pdf.numPages;
            	}
        });
				}
				this.$nextTick(() => {
					if(!_this.numPages){
						let contentBox = document.getElementById('html_box_child').clientHeight 
					if(parseInt(contentBox)>600){
						_this.repository_showmore=true;
					}
					}
				})
        		
			}, response => {
//				console.log("error");
			});
			
		},
		methods: {
// 			mycollection(event) {
// 				console.log(event.target.style.color)
// 				if(!this.collection_flag) {
// 					this.collection_flag = 1;
// 					event.target.className = 'el-icon-star-on'
// 					event.target.style.color = 'blue'
// 				} else {
// 					this.collection_flag = 0;
// 					event.target.className = 'el-icon-star-off'
// 					event.target.style.color = ''
// 				}
// 
// 			},
			//
			relativedoc(code,type,urls){
				let _this=this;
				if(type=='2'){
					window.open(urls);
					return false;
				}
				
				_this.$http.get(
				_this.apiUrl+'index.php? m=Api&c=Content&a=repositoryDetail',
				{
					params: {  
						"uuid":code,
						'userCode':sessionStorage.getItem('usercode')
					}  
				}
			).then(response => {
				
				//进行数据验证
				if(response.body.status != 1){
					
					//显示错误页面
//					alert('请求错误');
					return;
				}
				
				if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == ""){
					
					//显示空数据页面
//					alert('没有数据');
					return;
				}
				this.coverphoto=response.body.data.vc_coverphoto;
				this.title = response.body.data.vc_title;
				this.view = response.body.data.vc_page_view;
				this.source = response.body.data.vc_source;
				this.content = response.body.data.vc_content;
				this.createtime = response.body.data.dt_createtime;
				this.collection_flag = response.body.data.is_collection;
				this.correlation = response.body.data.correlation;
				this.contentType = response.body.data.n_contenttype;
				
				this.contentShow = 1;
				//根据类型判断
				if(this.contentType==1){
					this.html1=this.content;
				}else{
				let loadingTask = pdf.createLoadingTask(_this.apiUrl+this.content);
				this.src=loadingTask;
				this.src.then(pdf => {
            	this.numPages = pdf.numPages;
        });
				}
        		
        		this.$nextTick(() => {
					if(!_this.numPages){
						let contentBox = document.getElementById('html_box_child').clientHeight 
					if(parseInt(contentBox)>600){
						_this.repository_showmore=true;
					}
					}
				})
        		
			}, response => {
//				console.log("error");
			});
				
				
			},
			//收藏
			collectResponse(event){
				let _this=this;
				//判断用户是否登录
				if(this.isLogin()){
					
					//判断是收藏还是取消收藏
					if(!this.collection_flag){
						var url = _this.apiUrl+"index.php?m=Api&c=user&a=collectionAdd";
					}else{
						var url = _this.apiUrl+"index.php?m=Api&c=user&a=saveCollection"
					}
					
					//发送请求,收藏或取消收藏
					this.$http.post(url,
						{
							userCode:sessionStorage.getItem('usercode'),
							type:3,
							contentCode:this.uuid
						},
						{emulateJSON: true}
					).then(
						(response)=>{
					
							//判断是否收藏|取消收藏成功
							if(response.body.status == 1){
								sessionStorage.setItem('isRefresh',true);
								if(!this.collection_flag) {
									this.collection_flag = 1;
									event.target.className = 'el-icon-star-on'
									event.target.style.color = '#076bf2'
								} else {
									this.collection_flag = 0;
									event.target.className = 'el-icon-star-off'
									event.target.style.color = ''
								}
									
									
							}else{
//								alert(response.body.massage);
							}	
						
						},
						(error)=>{
//							console.log("error");
						}
					);
				}
			},
			
			//提问
			issueResponse(){
				//判断用户是否登录
				if(this.isLogin()){
					
					//弹出提问框
					this.$refs.submitquestionpop.opensubmitquestionpop('3',this.title);
				}
			},
			
			//判断是否登录
			isLogin(){
				
				//判断当前是否为登录状态
				if(typeof sessionStorage.getItem('usercode') == "undefined" || sessionStorage.getItem('usercode') == null || sessionStorage.getItem('usercode') == ""){
					
					//弹出登录页面
//					alert('请先登录');
					this.$message({
								message: '请先登录',
								type: 'warning',
								customClass: 'message-warning',
							});
					//显示登录页面
//					this.$refs.commonhead.flag = true;
					
					return false;
				
				}else{
					
					return true;
				}
				
			},
			
			//复制分享链接
			copyurl(){
				// var Url = 'http://39.104.14.210/dataGalaxy'+this.content;
				var oInput = document.createElement('textarea');
				oInput.value = this.shareUrl;
				document.body.appendChild(oInput);
				oInput.select(); // 选择对象
				document.execCommand("Copy"); // 执行浏览器复制命令
				oInput.className = 'oInput';
				oInput.style.display='none';
				this.$message({
								message: '复制成功',
								type: 'warning',
								customClass: 'message-warning',
							});
			},
			
			jumpRepositoryDetail(uuid){
				this.$router.push({
					path: 'correlation',
					query: {
						uuid: uuid
					}
				})
			},
			//查看更多
			showmorepage() {
				if(typeof sessionStorage.getItem('usercode') == "undefined" || sessionStorage.getItem('usercode') == null || sessionStorage.getItem('usercode') == ""){
					
					//弹出登录页面
					
					this.$message({
								message: '请先登录',
								type: 'warning',
								dangerouslyUseHTMLString:true,
								customClass: 'message-warning',
							});
					//显示登录页面
//					this.$refs.commonhead.flag = true;
					
					return false;
				
				}else{
					if(this.contentType=='1'){
						document.getElementById('html_box').style.height='auto';
						document.getElementById('re_showmore').style.display='none';
					}else{
						let a=this.pagea
					if(this.pagea<this.numPages){
						this.pagea=this.numPages
						document.getElementById('re_showmore').style.display='none';
				
					}else{
//						alert('已经到最后了，没有更多了')
					}
					}
					
				}
			},
		}
	}
</script>

<style lang="scss" >
    #html_box iframe{
    	width: 100%;
    }
	#repositorydetai{
		width: 100%;
		background: white;
		.repositprymain{
			overflow: hidden;
			width: 1200px;
			margin: 0 auto;
			.repositorycontent{
				min-height: 969px;
				width: 944px;
				float: left;
				h2{
					margin-top: 50px;
					text-align: left;
				}
				ul{
					font-size: 14px;
					height: 70px;
					line-height: 70px;
					text-align: left;
					li{
						float: left;
						margin-right: 10px;
						list-style: none;
						.source_img{
							/*margin: 0 5px;*/
							display: inline-block;
							height: 70px;
							line-height: 70px;
							width:24px;
							overflow:hidden;
							/*border-radius: 50%;*/
							/*background: #076bf2;*/
							/*color: white;
							font-size: 16px;*/
							text-align: center;
							i{
							border-radius: 50%;
							background: #076bf2;
							color: white;
							height: 24px;
							width: 24px;
							text-align: center;
							line-height: 24px;
							font-size: 16px;	
							}
						}
						span{
							display: inline-block;
							height: 70px;
							line-height: 70px;
							width:24px;
							margin: 0 5px;
							
						}
						a{
							font-size: 16px;
							/*display: inline-block;*/
							/*height: 24px;
							line-height: 24px;*/
						}
					}
					a{
						float: right;
					}
				}
				.showcontent{
					width: 944px;
					
					.repository_pdf{
						width: 100%;
						
					}
					#html_box{
					width: 944px;
					text-align: left;
					height: 600px;
					min-height: 600px;
					overflow: hidden;
						#html_box_child{
							img{
								width: 100%;
							}
							p{
								iframe{
									height: 531px;
									width: 944px;
									
								}
							}
						}
					}
				}
				
				.showmorere{
					width: 944px;
					height: 100px;
					line-height: 100px;
					text-align: center;
				}
			}
			.repositorycorrelation{
				float: right;
				width: 210px;
				margin-top: 30px;
				.related_doc{
					width:208px;
					margin-top:30px;
					border:1px solid #999;
					
					.title{
						font-weight: 600;
						font-size: 16px;
						background:#F3F3F3;
						height: 36px;
						line-height: 36px;
						text-align: left;
						text-indent: 10px;
						width:206px;
						margin: 1px auto;
					}
					ol{
						background: white;
						width: 190px;
						margin: 15px 10px 20px 10px;
						overflow: hidden;
						li{
							list-style: none;
							font-size: 16px;
							float: left;
							width:190px;
							/*margin: 10px auto;*/
							
							h5{
								color: #666;
								font-weight: 500;
								width: 100%;
								height: 18px;
								line-height: 18px;
								font-size: 16px;
								margin: 8px 0 16px 0;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								text-align: left;
							}
							
							.doc{
								font-size: 16px;
								margin: 8px auto;
								height: 16px;
								line-height: 16px;
								width: 190px;
								color: #999;
								.suiyi{
									text-indent: 5px;
									text-align: left;
									float: left;
									display: block;	
									height: 16px;
									line-height: 16px;
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
									span{
										float: left;
										display: block;
									}
								}
								span{
									/*max-width: 40px;*/
									float: right;
									display: block;
									height: 16px;
									line-height: 16px;
								}
							}
							
						}
					}
				}
				.share_link{
					width:208px;
					margin-top:30px;
					border:1px solid #999;
					.title{
						width: 206px;
						margin: 1px auto;
						font-weight: 600;
						font-size: 16px;
						background:#F3F3F3;
						height: 36px;
						line-height: 36px;
						text-align: left;
						text-indent: 10px;
					}
					.share{
						display: block;
						width:208px;
						margin: 20px 0 10px 16px;
						text-align: left;
					}
					.inputwrap{
						width: 190px;
						margin: 0 auto;
						.textarea1{
							box-sizing: border-box;
							color: #73777A;
							font-size: 16px;
							width: 190px;
							max-width: 190px;
							height: 150px;
							resize: none;
							color: #2c3e50;
							padding: 5px;
						}
					}
					.span_button{
						width: 190px;
						height: 36px;
						line-height: 36px;
						background: #076BF2;
						margin: 20px auto;
						display: block;
						cursor: pointer;
						color: white;
					}
				}
				
				.willask1{
					float: right;
					width: 208px;
					height:38px ;
					border: 1px solid #076BF2;
					margin-top: 50px;
					color: #076BF2;
					line-height: 38px;
					text-align: center;
				}
			}
		}
		
	}
</style>


// WEBPACK FOOTER //
// src/detail/repositorydetail.vue